import getImage from "./GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../../../Utils/Patient";
import ReportsAPI from "./../../../../Reports/api/reports_api";

const forumulacionPDF = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFFormula", data);
  const { nombres, apellido1, apellido2, reg_medico, especialidad } =
    data.professional;
  let esp = especialidad !== undefined ? especialidad : "";
  let body = [];

  const fecha_impresion = moment(new Date()).format("DD-MM-YYYY h:mm");
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.names;

  const city = data.profile.direccion.id_ciudad;
  const dept = data.profile.direccion.id_dpto;
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  let docContent = [];
  const supportDoc = data?.medicoApoyo[0];
  console.log("location", getCity, deptoProfile);

  const format_today = moment(data.infoAdmission?.admision?.fecha).format(
    "DD [de] MMMM [de] YYYY"
  );



  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\n Nit: " +
              data.profile.nit +
              "\n" +
              data.profile.direccion.direccion +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2 +
              " \n Fecha de Atención: " +
              moment(data.infoAdmission?.admision?.fecha).format("DD-MM-YYYY"),
            style: "head",
          },
        ],
      ],
    },
  };

  body[0] = [
    { text: "No.", style: "textStyle", bold: true },
    { text: "Nombre el Medicamento", style: "textStyle", bold: true },
    { text: "Concentración", style: "textStyle", bold: true },
    { text: "Forma Farmacéutica", style: "textStyle", bold: true },
    { text: "Via", style: "textStyle", bold: true },
    { text: "Dosis", style: "textStyle", bold: true },
    { text: "Frecuencia", style: "textStyle", bold: true },
    { text: "Duración / Tratamiento / Días", style: "textStyle", bold: true },
    { text: "Cant.", style: "textStyle", bold: true },
  ];
  if (data.from === "IMP") {
    for (let i = 0; i < data.ordenes.tratamiento.tratamiento.length; i++) {
      body[i + 1] = [
        { text: i + 1, style: "tableTexStyle" },
        {
          text: data.ordenes.tratamiento.tratamiento[i].principio_activo,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].concentracion,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].forma_farmaceutica,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].via_administracion,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].dosis,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].frecuencia === "Otros" ? data.ordenes.tratamiento.tratamiento[i].otra_frecuencia ?? data.ordenes.tratamiento.tratamiento[i].frecuencia : data.ordenes.tratamiento.tratamiento[i].frecuencia ,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].duracion,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.tratamiento.tratamiento[i].unidades_requeridas,
          style: "tableTexStyle",
        },
      ];
    }
  } else {
    for (let i = 0; i < data.ordenes.length; i++) {
      body[i + 1] = [
        { text: i + 1, style: "tableTexStyle" },
        { text: data.ordenes[i].activePrinciple, style: "tableTexStyle" },
        { text: data.ordenes[i].concentration, style: "tableTexStyle" },
        { text: data.ordenes[i].pharmaceuticalForm, style: "tableTexStyle" },
        { text: data.ordenes[i].route, style: "tableTexStyle" },
        { text: data.ordenes[i].dose, style: "tableTexStyle" },
        { text: data.ordenes[i].frequency, style: "tableTexStyle" },
        { text: data.ordenes[i].duration, style: "tableTexStyle" },
        { text: data.ordenes[i].units, style: "tableTexStyle" },
      ];
    }
  }


  const signatureColumn = [
    {
      layout: "headerLineOnly",
      margin: [10, 25, 0, 0],
      table: {
        widths: [125],
        headerRows: 1,
        body: [
          [
            {
              image: await getImage(data.firmDoctor),
              fit: [130, 60],
              alignment: "center",
            },
          ],
          [
            {
              text: `Dr. ${data.professional.nombres} ${data.professional.apellido1} ${data.professional.apellido2}\n${data.professional.especialidad}\nREG-${data.professional.reg_medico}`,
              style: "medicStyle",
            },
          ],
        ],
      },
    },
  ];

  if (data.firmDoctorSupport !== null && supportDoc !== undefined) {
    signatureColumn.push({
      layout: "headerLineOnly",
      margin: [10, 5, 30, 0],
      table: {
        widths: [125],
        headerRows: 1,
        body: [
          [
            {
              image: await getImage(data?.firmDoctorSupport),
              fit: [130, 60],
              alignment: "center",
            },
          ],
          [
            {
              text: `Dr. ${supportDoc?.nombres} ${supportDoc?.apellido1} ${supportDoc?.apellido2}\n${supportDoc?.especialidad}\nREG-${supportDoc?.reg_medico}`,
              style: "medicStyle",
            },
          ],
        ],
      },
    });
  }

  docContent.push({
    columns: signatureColumn,
    columnGap: 40,
  });

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [20, 50, 20, 20],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              { text: name, style: "head" },
              { text: "Fecha Impresión: " + fecha_impresion, style: "head" },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 0, 5],
      };
    },
    content: [
      {
        text: "FORMULA MÉDICA",
        style: "tableheader",
        alignment: "center",
        margin: [0, 10, 0, 0],
      },
      {
        text:
          "Lugar y Fecha de la Prescripción: " +
          getCity[0].ciunom +
          ", " +
          format_today,
        style: "textStyle",
        margin: [0, 10, 0, 0],
      },
      {
        text:
          typeof data.third?.nombre === "undefined"
            ? ""
            : "ENTIDAD: " + data.third?.nombre,
        style: "textStyle",
        bold: true,
      },
      {
        // auto-sized columns have their widths based on their content
        margin: [0, 5, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*"],
          body: [
            [
              {
                text: "Datos del Paciente ",
                style: "tableheader",
                colSpan: 4,
                border: [false, false, false, true],
              },
              "",
              "",
              "",
            ],
            [
              { text: "Nombre ", bold: true, style: "textStyle" },
              { text: data.names, style: "textStyle" },
              {
                text: "Documento de Identificación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.typeOfDocument + " " + data.documentNumber,
                style: "textStyle",
              },
            ],
            [
              { text: "Edad ", bold: true, style: "textStyle" },
              { text: calculateAgeParse(data.birthday), style: "textStyle" },
              { text: "Genero ", bold: true, style: "textStyle" },
              { text: data.gender, style: "textStyle" },
            ],
            [
              {
                text: "Historia Clínica ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text:
                  data.id_historia !== undefined && data.id_historia !== null
                    ? data.id_historia
                    : "",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: "Regimen: ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text:
                  data.regime !== undefined && data.regime !== null
                    ? data.regime
                    : "",
                style: "textStyle",
                border: [false, false, false, true],
              },
            ],
          ],
        },
      },

      data.from === "HC" && typeof data.ordenes !== "[]"
        ? {
            margin: [0, 10, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: [
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "*",
                "auto",
              ],
              headerRows: 1,
              body: body,
            },
          }
        : data.ordenes.tratamiento.tratamiento.length > 0
        ? {
            margin: [0, 10, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: [
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "*",
                "auto",
              ],
              headerRows: 1,
              body: body,
            },
          }
        : null,
      data.from === "HC" &&
      data.medicalObservation !== undefined &&
      data.medicalObservation !== null &&
      data.medicalObservation !== ""
        ? {
            margin: [0, 10, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: ["auto", "*"],
              headerRows: 1,
              body: [
                [
                  { text: "Observaciones: ", bold: true, style: "textStyle" },
                  { text: data.medicalObservation, style: "textStyle" },
                ],
              ],
            },
          }
        : data.ordenes.ordenes.ordenes.medicalObservation !== undefined &&
          data.ordenes.ordenes.ordenes.medicalObservation !== null &&
          data.ordenes.ordenes.ordenes.medicalObservation !== ""
        ? {
            margin: [0, 10, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: ["auto", "*"],
              headerRows: 1,
              body: [
                [
                  { text: "Observaciones: ", bold: true, style: "textStyle" },
                  {
                    text: data.ordenes.ordenes.ordenes.medicalObservation,
                    style: "textStyle",
                  },
                ],
              ],
            },
          }
        : null,

      docContent,
    ],

    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 9,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 10, 0, 0],
        fontSize: 9,
        alignment: "left",
        font: "OpenSans",
        bold: true,
      },
    },
  };

  //pdfMake.createPdf(documentDefinition).open();
  if (data.from === "IMP") {
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
      document.getElementById("pdfV").src = outDoc;
    });
  } else {
    pdfMake.createPdf(documentDefinition).open();
  }
};
export default forumulacionPDF;
